import React from 'react'
import { OneBlinkAppsError } from '@oneblink/apps-react'

export type SetErrorFn = (e?: Error | OneBlinkAppsError | string) => void

export default function useOneBlinkError(): [
  OneBlinkAppsError | undefined,
  SetErrorFn,
] {
  const [message, _setMessage] = React.useState<OneBlinkAppsError>()

  const setMessage = React.useCallback((e?: unknown) => {
    _setMessage(setOneBlinkError(e))
  }, [])

  return [message, setMessage]
}

export function setOneBlinkError(e?: unknown) {
  e && console.error(e)

  if (e === undefined || e instanceof OneBlinkAppsError) {
    return e
  } else if (e instanceof Error) {
    return new OneBlinkAppsError(e.message)
  } else {
    return new OneBlinkAppsError(
      typeof e === 'string' ? e : 'An unknown error has occurred',
    )
  }
}
